export const tenantSyncKeys = {
  planner: {
    syncPreview: (tenantName: string, variableName: string) =>
      ['planner', 'tenant-sync', tenantName, 'preview', variableName] as const,
  },
} as const;
